/*----------------------------------
- MEGAMENU PANEL COPY (SSOT)
-----------------------------------*/

/**
 * The headline and the one sentence under it, for each desktop megamenu. The Domains
 * headline is built at render time because it leads with a backend count, so only its
 * sentence lives here.
 */
export const LANDING_MENU_PANEL_COPY = {
    domains: {
        /** Shown when Product sent no total: the panel still needs a subject. */
        fallbackTitle: 'One-word domains',
        titleSuffix: 'one-word domains',
        lead: 'Each one carries its price, renewal, history and trademark risk.',
        screenerCta: 'Open the screener',
        /** Under the endings column: every TLD page is listed on the hub, not only the seven here. */
        allTldsLabel: 'See all TLDs',
        listsLabel: 'Lists',
        tldsLabel: 'By ending',
        sectorsLabel: 'By sector',
    },
    market: {
        title: 'What the domain market is doing',
        // Says what exists today and what does not. The mockup's "Sales, auctions and
        // news, with every figure linked to where it came from" claimed surfaces that were not
        // built; the sales page is live since ADR-0067, the auctions page since ADR-0076, the
        // registrar prices since ADR-0079.
        lead: 'Today’s news, the sales and auctions pages, the TLD pages, registrar prices, the agenda of launch dates and events, and the daily one-word picks.',
    },
    tools: {
        title: 'Free tools',
        // Not "No account needed": Multi-Appraisal runs inside the product, on Full Access since
        // the free plan was retired (ADR-0083). WHOIS and the checker give a visitor one live
        // lookup a day each with no account since 2026-10-09 (ADR-0078).
        lead: 'WHOIS and the availability checker answer one name a day each, no account needed. Multi-Appraisal runs on Full Access. The logo generator is being built.',
    },
} as const;
